import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingCommentReply } from './types/mailing-comment-reply.type';

/**
 * Fetches the comments associated with a specific mailing.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing for which to retrieve comments.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array of {@link MailingComment}.
 * @throws Will throw an error if the request fails.
 */
export const getMailingComments = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingCommentReply[]>>(formatString(Uri.mailing.getComments, mailingId.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
